import React from "react";
import LabeledCheckBox from "./LabeledCheckBox";
import EventBubble from "./EventBubble";
import styled from "styled-components";

const ScoreCardContainer = styled.div.attrs({
  className: "ScoreCard",
})`
  padding: 0.5em;
`;

const CheckboxesContainer = styled.div.attrs({
  className: "Checkboxes",
})`
  display: flex;
  flex-wrap: wrap;
`;

const CheckboxContainer = styled.div.attrs({
  className: "Checkbox",
})`
  flex: 0 0 100%;

  @media (min-width: 680px) {
    flex: 0 0 50%;
  }

  @media (min-width: 1280px) {
    flex: 0 0 33.3333%;
  }
`;

class ScoreCard extends React.PureComponent {
  render() {
    let { event, skills, selectedSkills, toggleEventSkill } = this.props;

    return (
      <ScoreCardContainer>
        <EventBubble event={event} />
        <CheckboxesContainer>
          {skills.map(skill => (
            <CheckboxContainer key={skill.id}>
              <LabeledCheckBox
                label={skill.name}
                type="checkbox"
                id={skill.id}
                checked={selectedSkills.has(skill.id)}
                onChange={() => toggleEventSkill(event.id, skill.id)}
              />
            </CheckboxContainer>
          ))}
        </CheckboxesContainer>
      </ScoreCardContainer>
    );
  }
}

export default ScoreCard;
